import React from 'react';
import {
  Show,
  SimpleShowLayout,
  TextField,
  BooleanField,
  DateField,
  ReferenceManyField,
  Datagrid,
  EditButton,
  TopToolbar,
} from 'react-admin';
import { Box, Paper, Typography, Grid } from '@mui/material';

const ShowActions = () => (
  <TopToolbar>
    <EditButton />
  </TopToolbar>
);

export const ServiceProviderShow = () => (
  <Show actions={<ShowActions />}>
    <SimpleShowLayout>
      <Box sx={{ width: '100%', maxWidth: 1000 }}>
        <Paper elevation={1} sx={{ p: 3, mb: 3 }}>
          <Typography variant="h6" gutterBottom color="primary" sx={{ mb: 3 }}>
            Service Provider Details
          </Typography>
          <Grid container spacing={3}>
            <Grid item xs={12} md={6}>
              <Typography variant="subtitle2" color="textSecondary">Business Name</Typography>
              <TextField source="name" />
            </Grid>
            <Grid item xs={12} md={6}>
              <Typography variant="subtitle2" color="textSecondary">Status</Typography>
              <BooleanField source="active" />
            </Grid>
            <Grid item xs={12}>
              <Typography variant="subtitle2" color="textSecondary">Address</Typography>
              <TextField source="address" emptyText="Not provided" />
            </Grid>
            <Grid item xs={12} md={4}>
              <Typography variant="subtitle2" color="textSecondary">City</Typography>
              <TextField source="city" emptyText="Not provided" />
            </Grid>
            <Grid item xs={12} md={4}>
              <Typography variant="subtitle2" color="textSecondary">Province/State</Typography>
              <TextField source="provinceState" emptyText="Not provided" />
            </Grid>
            <Grid item xs={12} md={4}>
              <Typography variant="subtitle2" color="textSecondary">Country</Typography>
              <TextField source="country" emptyText="Not provided" />
            </Grid>
            <Grid item xs={12} md={6}>
              <Typography variant="subtitle2" color="textSecondary">Phone Number</Typography>
              <TextField source="phoneNumber" emptyText="Not provided" />
            </Grid>
            <Grid item xs={12} md={6}>
              <Typography variant="subtitle2" color="textSecondary">Created</Typography>
              <DateField source="createdAt" showTime />
            </Grid>
          </Grid>
        </Paper>

        <Paper elevation={1} sx={{ p: 3 }}>
          <Typography variant="h6" gutterBottom color="primary" sx={{ mb: 3 }}>
            Recent Maintenance Records
          </Typography>
          <ReferenceManyField
            reference="equipment-maintenance"
            target="serviceProviderId"
            label=""
          >
            <Datagrid>
              <TextField source="equipment.name" label="Equipment" />
              <DateField source="serviceDate" />
              <TextField source="serviceType" />
              <TextField source="totalCost" />
              <EditButton />
            </Datagrid>
          </ReferenceManyField>
        </Paper>
      </Box>
    </SimpleShowLayout>
  </Show>
);